import { Grid, Stack } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import TopSection from "../../../Components/Common/Top/TopSection";
import BPMaterialConfig from "./BPMaterialConfig";
import { setActiveDataElement } from "../../../redux/userSlice";

function BPCustomConfiguration() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveDataElement("Bottler Business Plan"));
  }, [dispatch]);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection
              title="Business Plan Custom Configuration"
            />
            <div class="container">
                <BPMaterialConfig />
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
}
export default BPCustomConfiguration
